import { Config } from '@cargos/sprintpay_frontend_core_api/lib/models';
import { getEnvironment } from '.';
import { store } from '../store';

export const getSprintPayMethodsConfig = (): Config => ({
    token: store.getState().authReducer.token || '',
    environment: getEnvironment(),
});
